import React from 'react'

const Questions = () => {
  return (
    <div>
      <h1>Questions Coming Soon...</h1>
    </div>
  )
}

export default Questions
